module.exports = __webpack_public_path__ + "files/c24905dff185ec5e642b3d756abe8414.png";